/**
 * The product's wordmark — `rsys`, with its leading `r` in red.
 *
 * **One definition, because there were already three.** The sign-in page, the forced
 * password change and the sidebar header each rendered the name as plain text, so a
 * two-tone treatment written out at each of them is one the fourth call site gets wrong —
 * and a wordmark that is red on two screens and slate on a third is not a wordmark. This is
 * the "a block hand-rolled at a SECOND call site belongs in the shell" rule reaching the
 * product's own name.
 *
 * **It is a FRAGMENT, so the caller keeps the element and the typography.** The two auth
 * pages head it as an `<h1 className="text-lg font-semibold text-slate-800">`; the sidebar
 * draws a truncating `<p className="text-sm …">` beside the rail's mark. Those are genuinely
 * different — a heading and a label, two sizes, one of them clipped — and what is shared is
 * which letters and which one is red, never how big it is. Owning the element here would
 * mean a prop per difference, which is a wrapper pretending to be a component.
 *
 * **`red-700`, and the step was chosen by MEASURING the grounds it actually sits on.**
 * Neither of them is white: the auth pages stand on `slate-100` and the rail on
 * `--color-rail`. `red-600` reads most vividly and lands at **4.35:1** on the auth ground
 * and **4.24:1** on the rail — fine at 19px/600, which is WCAG large text, and BELOW the
 * 4.5:1 normal-text floor at the sidebar's 15px. `red-700` is **5.86:1** and **5.71:1**,
 * clears AA at both sizes, and is still plainly red at 15px; `red-800` starts reading as
 * maroon there. It is also the product's dominant red already — 166 call sites to
 * `red-600`'s 37, 165 of them predating this one — so this is the consistent step as well
 * as the legible one.
 *
 * WCAG 1.4.3 exempts a logotype from any contrast minimum, so `red-600` would have been
 * defensible. It was not taken because clearing the bar cost nothing visible, and a number
 * that clears it needs no exemption argued on its behalf.
 *
 * **Red means destructive or invalid everywhere else in this product** — a delete, a
 * rejected field, a `blocked` status pill. Here it is the brand's own mark. Product call,
 * 02 Oct 2026, and it is scoped to this component precisely so the tone cannot spread: a
 * call site renders `<Wordmark />` and has no class of its own to copy.
 *
 * **The two halves sit on ONE line and share no whitespace.** JSX collapses a newline
 * between an element and the text after it, so the word would survive a reformat — but it
 * would survive it by accident, and `rsys` must never be able to come out as `r sys`.
 */
export function Wordmark() {
  return (
    <>
      <span className="text-red-700">r</span>sys
    </>
  );
}
